$(function init(){

	log("~~~ [ Le Grande Init ] ~~~");

	// Initialize analytics - finally
	//HHS.analytics.init();

	// Initialize components
	HHS.components.init();

	// Initialize actions
	HHS.actions.init();

});
